import { render, staticRenderFns } from "./DeliveryTruckSvg.vue?vue&type=template&id=66196c94&scoped=true"
import script from "./DeliveryTruckSvg.vue?vue&type=script&lang=js"
export * from "./DeliveryTruckSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66196c94",
  null
  
)

export default component.exports